import { render, staticRenderFns } from "./OnePageLayout.vue?vue&type=template&id=064d12a2&scoped=true&"
import script from "./OnePageLayout.vue?vue&type=script&lang=js&"
export * from "./OnePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./OnePageLayout.vue?vue&type=style&index=0&id=064d12a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d12a2",
  null
  
)

export default component.exports